import React from 'react';
import Share from './Share';
import Content from './Content';

const Base = (props) => {
    const text = props.text.replace(/\*(.*?)\*/g, "<strong>$1</strong>");

    var profileImage = (props.type === 5 || props.isMyTimeline) ?
        <div className="c-headshot" style={{ backgroundImage: 'url(' + props.photoUrl + ')' }}></div> :
        <a href={props.urls.detail + '?friend=' + props.secureid}>
            <div className="c-headshot" style={{ backgroundImage: 'url(' + props.photoUrl + ')' }}></div>
        </a>;

    return (
        <div className="c-module">
            <div className="c-linkBlock">
                <div className="c-linkBlock__wrapper">
                    <div className="c-linkBlock__item">
                        {profileImage}
                    </div>
                    <div className="c-linkBlock__headers">
                        <div className="c-linkBlock__title" dangerouslySetInnerHTML={{__html: text}}></div>
                        <div className="c-linkBlock__subtitle">{props.created}</div>
                    </div>
                </div>
                {props.content && <Content content={props.content} imageUrl={props.imageUrl}/>}
                {props.type !== 5 &&
                    props.shareUrl &&
                    <Share
                        id={props.id}
                        urls={props.urls}
                        likes={props.likes}
                        likedByMe={props.likedByMe}
                        isMyTimeline={props.isMyTimeline}
                        shareUrl={props.shareUrl}
                        text={props.text}/>
                }
            </div>
        </div>
    );
}

Base.propTypes = {
    id: React.PropTypes.number.isRequired,
    secureid: React.PropTypes.string.isRequired,
    urls: React.PropTypes.object.isRequired,
    text: React.PropTypes.string.isRequired,
    created: React.PropTypes.string.isRequired,
    photoUrl: React.PropTypes.string.isRequired,
    content: React.PropTypes.oneOfType([
        React.PropTypes.bool,
        React.PropTypes.object
    ]),
    likes: React.PropTypes.number.isRequired,
    likedByMe: React.PropTypes.bool.isRequired,
    isMyTimeline: React.PropTypes.bool.isRequired,
    shareUrl: React.PropTypes.string.isRequired,
    imageUrl: React.PropTypes.string.isRequired,
    type: React.PropTypes.number.isRequired
};

export default Base;
